module.exports = __webpack_public_path__ + "img/1686881490898-IMG_2805.jpeg.ec36d0ef.webp";